import { h } from "vue";
import { RouteRecordRaw, RouterView } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    // Equipments
    {
        path: "/production/equipments",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Equipments",
                meta: { title: "Equipments" },
                component: () => import("@/views/production/equipments/Equipments.vue"),
            },
            {
                path: "create",
                name: "EquipmentCreate",
                meta: { title: "Equipments" },
                component: () => import("@/views/production/equipments/components/Equipment.vue"),
            },
            {
                path: ":id/edit",
                name: "EquipmentEdit",
                meta: { title: "Equipments" },
                component: () => import("@/views/production/equipments/components/Equipment.vue"),
                props: true,
            },
        ],
    },

    // Articles
    {
        path: "/production/articles",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Articles",
                meta: { title: "Artikel" },
                component: () => import("@/views/production/articles/Articles.vue"),
            },
            {
                path: "create/:tab?",
                name: "ArticleCreate",
                meta: { title: "Artikel" },
                component: () => import("@/views/production/articles/components/Article.vue"),
            },
            {
                path: ":id/edit/:tab?",
                name: "ArticleEdit",
                meta: { title: "Artikel" },
                component: () => import("@/views/production/articles/components/Article.vue"),
                props: true,
            },
            {
                path: ":articleId/suppliers/create",
                name: "ArticleSupplierCreate",
                meta: { title: "Artikel" },
                component: () => import("@/views/production/articles/components/Supplier.vue"),
                props: true,
            },
            {
                path: ":articleId/suppliers/:id/edit",
                name: "ArticleSupplierEdit",
                meta: { title: "Artikel" },
                component: () => import("@/views/production/articles/components/Supplier.vue"),
                props: true,
            },
        ],
    },

    //Recipes
    {
        path: "/production/recipes",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Recipes",
                meta: { title: "Rezepte" },
                component: () => import("@/views/production/recipes/Recipes.vue"),
            },
            {
                path: "create/:tab?",
                name: "RecipeCreate",
                meta: { title: "Rezepte" },
                component: () => import("@/views/production/recipes/components/Recipe.vue"),
            },
            {
                path: ":id/edit/:tab?",
                name: "RecipeEdit",
                meta: { title: "Rezepte" },
                component: () => import("@/views/production/recipes/components/Recipe.vue"),
                props: true,
            },
            {
                path: ":recipeId/edit/create-serving-size",
                name: "RecipeServingCreate",
                meta: { title: "Rezepte" },
                component: () => import("@/views/production/recipes/components/ServingSize.vue"),
                props: true,
            },
            {
                path: ":recipeId/edit/edit-serving-size/:servingId",
                name: "RecipeServingEdit",
                meta: { title: "Rezepte" },
                component: () => import("@/views/production/recipes/components/ServingSize.vue"),
                props: true,
            },
        ],
    },

    // Staffs
    {
        path: "/production/staffs",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Staffs",
                meta: { title: "Personal" },
                component: () => import("@/views/production/staffs/Staffs.vue"),
            },
            {
                path: "create",
                name: "StaffCreate",
                meta: { title: "Personal" },
                component: () => import("@/views/production/staffs/components/Staff.vue"),
            },
            {
                path: ":id/edit",
                name: "StaffEdit",
                meta: { title: "Personal" },
                component: () => import("@/views/production/staffs/components/Staff.vue"),
                props: true,
            },
        ],
    },

    // ProductionList
    {
        path: "/production/production-list",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: ":tab?",
                name: "ProductionList",
                meta: { title: "Produktionsliste" },
                component: () => import("@/views/production/productionlist/ProductionList.vue"),
                props: true,
            },
            {
                path: "/productionprogress",
                name: "ProductionProgress",
                meta: { title: "Produktionsliste" },
                component: () => import("@/views/production/productionlist/components/ProductionProgress.vue"),
                props: false,
            },
            {
                path: ":id/produce/:name",
                name: "KitchenView",
                meta: { title: "Produktionsliste" },
                component: () => import("@/views/production/productionlist/components/KitchenView.vue"),
                props: true,
            },
            {
                path: ":id/edit/:name",
                name: "EditSaved",
                meta: { title: "Produktionsliste" },
                component: () => import("@/views/production/productionlist/components/EditSavedList.vue"),
                props: true,
            },
        ],
    },

    // OrderList
    {
        path: "/production/order-list",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: ":tab?",
                name: "OrderList",
                meta: { title: "Bestellliste" },
                component: () => import("@/views/production/orderlist/OrderList.vue"),
                props: true,
            },
            {
                path: ":id/view",
                name: "OrderListDetail",
                meta: { title: "Bestellliste" },
                component: () => import("@/views/production/orderlist/tabs/OrderList.vue"),
                props: true,
            },
        ],
    },

    // PackingList
    {
        path: "/production/packing-list",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: ":tab?",
                name: "PackingList",
                meta: { title: "Abpackliste" },
                component: () =>
                    import("@/views/production/packinglist/PackingList.vue"),
                props: true,
            },
        ],
    },

];

export default routes;
